export enum STATUS {
    pending = 'pending',
    loading = 'loading',
    success = 'success',
    error = 'error'
}